import { Component, signal, inject, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { LoaderService } from './core/services/loader.service';
import { FunnelService } from './features/users/components/funnel/funnel.service';
import { BrandingService } from './core/services/branding.service';
import { SharedStateService } from './core/services/first-layer.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss',
})
export class AppComponent {
  logoUrl = '';
  public isLanding = false;
  brandingId = '';
  showManualForm: boolean = true;

  constructor(
    private router: Router,
    private renderer: Renderer2,
    private loaderService: LoaderService,
    private funnelService: FunnelService,
    private brandingService: BrandingService,
    private stateService: SharedStateService
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  }

  ngOnInit(): void {
    this.stateService.setShowManualForm(true);
    this.stateService.showManualForm$.subscribe((value) => {
      this.showManualForm = value;
    });
    const urlParams = new URLSearchParams(window.location.search);
    this.brandingId = urlParams.get('brandingId') || '';
    if (this.brandingId) {
      this.brandingService.setBrandingId(this.brandingId);
    } else {
      this.brandingService.loadBrandingIdFromStorage();
    }

    // this.funnelService.getBrandingStyles(this.brandingId).subscribe((data) => {
    //   document.documentElement.style.setProperty(
    //     '--background-color',
    //     data.BackgroundColor
    //   );
    //   document.documentElement.style.setProperty(
    //     '--text-color',
    //     data.TextColor
    //   );
    //   document.documentElement.style.setProperty(
    //     '--button-text-color',
    //     data.ButtonTextColor
    //   );

    //   if (data.ButtonColor.length > 1) {
    //     document.documentElement.style.setProperty(
    //       '--button-gradient-start',
    //       data.ButtonColor[0]
    //     );
    //     document.documentElement.style.setProperty(
    //       '--button-gradient-middle',
    //       data.ButtonColor[1]
    //     );
    //     document.documentElement.style.setProperty(
    //       '--button-gradient-end',
    //       data.ButtonColor[2]
    //     );
    //   } else {
    //     document.documentElement.style.setProperty(
    //       '--button-gradient-start',
    //       data.ButtonColor[0]
    //     );
    //     document.documentElement.style.setProperty(
    //       '--button-gradient-end',
    //       data.ButtonColor[0]
    //     );
    //   }
    // });
  }

  saveBrandingIdOnce(brandingId: string): void {
    const storedId = localStorage.getItem('brandingId');
    if (!storedId) {
      localStorage.setItem('brandingId', brandingId);
    } else {
      this.brandingId = storedId;
    }
  }
}
